import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreDialog,
    {
      attrs: {
        value: _vm.value,
        "data-qa": "lpu_promotions_archive_dialog",
        title: _setup.title,
        size: _setup.isMobile ? "fullscreen" : "xl",
        "max-height": _setup.isMobile ? undefined : "80vh",
        divider: "",
      },
      on: {
        input: function ($event) {
          return _setup.emit("input", $event)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "prependBtn",
          fn: function ({ btnProps }) {
            return [
              _c(
                VBtn,
                _vm._b(
                  {
                    on: {
                      click: function ($event) {
                        return _setup.emit("input", false)
                      },
                    },
                  },
                  "v-btn",
                  btnProps,
                  false
                ),
                [_c("span", { staticClass: "ui-icon-close-not-a-circle" })]
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "promotions-archive-dialog",
          class: { "promotions-archive-dialog--mobile": _setup.isMobile },
        },
        [
          _setup.isLoading
            ? _c(
                "div",
                { staticClass: "d-flex align-center justify-center py-10" },
                [
                  _c(VProgressCircular, {
                    attrs: {
                      width: "2.5",
                      size: "42",
                      color: "primary",
                      indeterminate: "",
                    },
                  }),
                ],
                1
              )
            : _setup.html
            ? _c("div", {
                ref: "bodyRef",
                staticClass: "promotions-archive-dialog__body",
                attrs: { "data-qa": "lpu_promotions_archive_body" },
                domProps: {
                  innerHTML: _vm._s(
                    _setup.html /* eslint-disable-line vue/no-v-html */
                  ),
                },
                on: { click: _setup.onBodyClick },
              })
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }